module.exports = __webpack_public_path__ + "static/monthly-action-hours-headshots-square.d79211c9.png";